import React from "react";
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Icon from '@mui/material/Icon';

export default function Social() {
    return (
        (<Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
        >
            <Grid item>
                <Button>
                    <Link href="https://github.com/Timitan" target="_blank" rel="noopener">
                        <Icon className="fab fa-github" fontSize="large" style={{color: "#6e5494"}}></Icon>
                    </Link>
                </Button>
            </Grid>
            <Grid item>
                <Button>
                    <Link href="https://www.linkedin.com/in/timitan" target="_blank" rel="noopener">
                        <Icon className="fab fa-linkedin-in" fontSize="large" style={{color: "#0e76a8"}}></Icon>
                    </Link>
                </Button>
            </Grid>
            <Grid item>
                <Button>
                    <Link href="mailto:tim.tan5145@gmail.com" target="_blank" rel="noopener">
                        <Icon className="fa fa-envelope" fontSize="large" style={{color:"#3e65cf"}}></Icon>
                    </Link>
                </Button>
            </Grid>
        </Grid>)
    );
}
